import validationHelper from "component-common/dist/helpers/ValidationHelper";

export default validationHelper;



// WEBPACK FOOTER //
// ./src/helpers/ValidationHelper.js